import React, { useState } from "react";
import ListDropdown, { ListDropdownProps } from "../list/Dropdown";
import { Chevron } from "../../assets/svgs/icons";

type BubbleDropdownProps = {
  dropdown?: "off" | "on";
  items?: ListDropdownProps[];
};

const BubbleDropdown: React.FC<BubbleDropdownProps> = ({
  dropdown = "off",
  items,
}) => {
  const [isOpen, setIsOpen] = useState(dropdown === "on");

  // Figma colors
  const borderColor = "border-[#c5abfa]";
  const badgeText = "text-[#6d2ef2]";
  const divider = "bg-[#cccccc]";

  // Responsive container
  const containerBase = "box-border rounded-[20px] flex flex-col items-center";
  const openStyle = "bg-white border " + borderColor + " pt-2 pb-5 px-4 gap-5";
  const closedStyle =
    "border " + borderColor + " p-2 flex-row gap-1 justify-center";

  return (
    <div
      className={containerBase + " " + (isOpen ? openStyle : closedStyle)}
      data-name={`dropdown=${isOpen ? "on" : "off"}`}
    >
      <div
        className={
          "flex items-center justify-center gap-1 relative shrink-0 w-full cursor-pointer"
        }
        data-name="label"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <p
          className={
            `font-semibold ${badgeText} text-center ` +
            "text-[12px] md:text-[14px] tracking-[-0.24px] md:tracking-[-0.28px] leading-[16px] md:leading-[20px]"
          }
        >
          {isOpen ? "참고 자료 닫기" : "참고 자료 보기"}
        </p>
        <span
          className={
            "inline-flex items-center justify-center ml-1 " +
            "w-[20px] h-[20px] md:w-[24px] md:h-[24px]"
          }
        >
          <Chevron
            className={
              "w-full h-full transition-transform duration-200" +
              (isOpen ? " -rotate-90" : " rotate-90")
            }
            aria-label="chevron"
          />
        </span>
      </div>
      {isOpen && (
        <>
          {items.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col gap-3 items-start w-full relative"
              data-name="list/dropdown"
            >
              <ListDropdown
                badge={item.badge}
                title={item.title}
                content={item.content}
                url={item.url}
              />
              {idx < items.length - 1 && (
                <div className={`${divider} h-px w-full shrink-0`} />
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default BubbleDropdown;
